// @flow

import Request from '@insolus/request';
import type { RequestPromise } from '@insolus/request';

type Country = {|
    id: string,
    name: string
|};

// ------------------------------------------------------
// -
// -    Functions
// -
// ------------------------------------------------------

const all = (): RequestPromise<Country[]> => Request.get(`/countries`);

export default { all };
